<!--判断题-->
<template>
  <div class="item-box">
    <div class="title question-item-title">
      <span :class="{xinxin:isYes}"><i v-if="!$store.state.settingData.base.notorder">{{ number }}、</i></span><span class="title-type">{{question.subtype}}</span><span class="q-title" v-html="question.title"></span><span
        class="fenshu">(分值：{{question.score}}分)</span>
    </div>
    <div :class="['item-list',{active:currentItem === index && !isAnalysis}]"
         v-for="(item,index) in answers.option"
         @click="checkItem(index,item)">
      <div
          :class="['left',{trueItem:item.is_right && isAnalysis,falseItem:question.my_answer===index && isAnalysis}]">
        {{index | AB}}
      </div>
      <div class="right">
        {{item.label}}
        <span class="true" v-if="item.is_right && isAnalysis">(正确答案)</span>
        <div class="optionImg" v-if="$store.state.formType === 2 && item.img!==''">
          <img :src="item.img" alt="">
        </div>
      </div>
    </div>
    <p class="analysisText" v-if="isAnalysis">解析：<span v-html="question.answer_analysis"></span></p>
  </div>
</template>

<script>
    export default {
        name: "tPanDuan",
        props: {
            question: {
                type: Object,
                default() {
                    return {}
                }
            },
            number: {
                type: Number,
                default() {
                    return null;
                }
            },
            isAnalysis: {
                type: Boolean,
                default() {
                    return false
                }
            }
        },
        data() {
            return {
                currentItem: '',
                answers: [],
                isYes: false
            }
        },
        mounted() {
            this.answers = this.question.answers
            this.currentItem = this.$store.state.user_answers[this.question.id]
            this.question.verify_rule !== null ? this.isYes = this.question.verify_rule.is_require : this.isYes = false
        },
        methods: {
            checkItem(index, item) {
                if (!this.isAnalysis) {
                    this.currentItem = index
                    let obj = {}
                    obj[this.question.id] = this.currentItem
                    this.$store.dispatch('userAnswersActions', obj)
                }
            }
        },
        filters: {
            AB: function (index) {
              let ab =  ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z']
              return ab[index];
            }
        },
        watch: {
            question: {
                handler(newValue, oldValue) {
                    this.question = newValue
                    this.answers = newValue.answers
                    this.currentItem = this.$store.state.user_answers[this.question.id]
                    this.question.verify_rule !== null ? this.isYes = this.question.verify_rule.is_require : this.isYes = false
                },
                deep: true
            },
            number: {
                handler(newValue, oldValue) {
                    this.number = newValue
                },
                deep: true
            }
        }
    }
</script>

<style lang="scss" scoped>

  .xinxin {
    position: relative;
    margin-right: 5px;
    padding-left:8px;
    &:after {
      content: "*";
      display: inline-block;
      margin-right: 4px;
      font-size: 16px;
      color: rgb(255, 51, 0);
      position: absolute;
      top: 0px;
      left: 0px;
    }
  }

  .title-type {
    color: #0D5EFF;
    font-size: 14px;
    background-color: #E6EDF9;
    border-radius: 4px;
    padding: 4px 5px;
    font-weight: 500;
    margin-right: 6px;
  }

  .fenshu {
    color: #cc5252;
    margin-left: 5px;
  }


  .item-list {
    display: flex;
    padding-bottom: 20px;
    align-items: center;

    &:last-child {
      padding-bottom: 0;
    }

    .left {
      width: 30px;
      height: 30px;
      border: 1px solid #dddddd;
      color: #222222;
      font-size: 15px;
      font-weight: 500;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }

    .right {
      font-size: 16px;
      color: #303133;
      /*flex: 1;*/
      padding-top: 2px;
      line-height: 28px;
      padding-left: 10px;
    }

    .true {
      font-size: 16px;
      color: #FFBC5D;
      font-weight: 500;
      padding-left: 10px;
    }

    &:hover {
      cursor: pointer;
    }
  }

  .active {
    .left {
      background-color: #0A4BCC;
      color: #fff;
    }
  }


  .falseItem {
    background-color: #FF6766;
    color: #fff !important;
  }

  .trueItem {
    background-color: #5ECE70;
    color: #fff !important;
    border: none!important;
  }

  .analysisText {
    font-size: 14px;
    font-weight: 400;
    color: #909399;
    line-height: 27px;
    display: flex;

    > span {
      flex: 1;
    }
  }
</style>
